import { useState, useEffect, useRef } from "react";

import { Field } from "formik";
import PreviewImage from "../c&m/productos/PreviewImage";
import CompletarDatosCampos from "./CompletarDatosForm";
import { fechaSinGuiones } from '../tools/ConversionFechas'
import {
  usePlanes,
  useCarreras,
  useGrados,
  useOptions,
  useCuotas,
} from "./custom-hooks";

import { fetchApi } from "./helpers";

export default function AdmisionModal({
  setModal,
  setDataGridFecha,
  todosPlanes,
  props,
  closeAdmisionEdicion,
  datosSolicitud,
  datosInscripcion,
  solicitudSeleccionada,
  errors,
  handleSubmit,
  setFieldValue,
  isValid,
  values,
  handleEstadoSolicitud,
  obtenerDatosInscripcion,
  datosInscripcionStep1,
  url,
  headers,
  callFromReporte = false,
  setBotonProveniente,
  enviarFotoActualizacion,
  setDatosGradoParametro,
  sendPlanes
}) {


  const carreraRef = useRef(null);
  const fechaRef = useRef(null)

  const convertBlobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  const fileRef = useRef(null);
  

  const [nombrePlan, setNombrePlan] = useState("");
  //nombre del plan al que pertenece el id seleccionado
  //state de los grados tomados del grid
  const [gridSeleccionado, setGridSeleccionado] = useState({
    Carrera: "",
    Grado: "",
    Sede: "",
  });
  //state de los nombres de los grados tomados del combo del paso 1
  const [combosGrados, setCombosGrados] = useState({
    idGrado: "",
    idCarrera: "",
    idSede: "",
    idPlan: "",
  }); 
  //estado auxiliar que se envia al cambiar los combos de plan, sede, carrera y grado
  const [idsCombos, setIdsCombos] = useState({
    IdGrado: datosInscripcion?.Grado,
    IdSede: datosInscripcion?.Sede,
    IdCarrera: datosInscripcion?.Carrera,
    IdPlan: datosInscripcion?.Plan,
  });

  const options = useOptions(url, headers); // Sedes
  const [planes, handlePlanes] = usePlanes(url, headers, "IdSede"); // Planes
  const [carreras, handleCarreras] = useCarreras(url, headers, "IdPlan"); // Carreras
  const [grados, handleGrados] = useGrados(url, headers, "IdCarrera"); // Grados
  const [cuotas, handleCuotas] = useCuotas(url, headers, "IdGrado"); // Cuotas

  const obtenerCombos = async () => {
    await handlePlanes(datosInscripcionStep1.IdSede || datosSolicitud[0].IdSede, setFieldValue);
    await handleCarreras(
      datosInscripcionStep1.IdPlan || datosSolicitud[0].IdPlan,
      setFieldValue,
      datosInscripcionStep1.IdSede || datosSolicitud[0].IdSede
    );
    await handleGrados(
      datosInscripcionStep1.IdCarrera || datosSolicitud[0].IdCarrera,
      setFieldValue,
      datosInscripcionStep1.IdSede || datosSolicitud[0].IdSede
    );
    await handleCuotas(
      datosInscripcionStep1.IdGrado || datosSolicitud[0].IdGrado,
      setFieldValue,
      datosInscripcionStep1.IdSede,
    );
  };

  const [carnetId, setCarnetId] = useState({
    Id: "",
    Carnet: "",
  });

  function formatearFechaNacimiento(fecha) {
    //ponerle guines a la fecha
    if (fecha !== undefined) {
      let dia = fecha.substring(0, 2);
      let mes = fecha.substring(3, 5);
      let anio = fecha.substring(6, 10);
      let fechasinformato = `${anio}-${mes}-${dia}`;

      return fechasinformato;
    }
  }

  const getDataEncargado = async (id) => {
    const resSol = await fetchApi({
      url: url + "/utils/busquedas",
      headers: headers,
      content: {
        opcion: "ASPIRANTESGRAL_ID",
        IdSolicitud: id,
      },
    });
    handleEstadoSolicitud(resSol[0].EstadoSolicitud);
    setFieldValue("IdSolicitud", solicitudSeleccionada.Id);
    setFieldValue("id", solicitudSeleccionada.Id);
    //setFieldValue('FotoN',        resSol[0].FotoN)
    setFieldValue("EmailE", resSol[0].Email);
    setFieldValue("E_EmailE", resSol[0].Email);
    setFieldValue("E_Email", resSol[0].E_EmailE);
    setFieldValue("E_Depto", resSol[0].E_Depto);
    setFieldValue("Genero", solicitudSeleccionada.Sexo);
    setFieldValue("E_Nombres", solicitudSeleccionada.E_Nombres);
    setFieldValue("E_Apellidos", solicitudSeleccionada.E_Apellidos);
    setFieldValue("ColAnterior", solicitudSeleccionada.ColAnterior);
    setFieldValue("E_Edad", resSol[0].E_Edad);
    setFieldValue("E_Telcasa", resSol[0].E_Telcasa);
    setFieldValue("E_DPI", resSol[0].E_DPI);
    setFieldValue("E_EstadoCiv", resSol[0].E_EstadoCiv);
    setFieldValue("E_Ocupa", resSol[0].E_Ocupa);
    setFieldValue("Nacionalidad", resSol[0].Nacionalidad);
    setFieldValue("E_Direcc", resSol[0].E_Direcc);
    setFieldValue("E_Muni", resSol[0].E_Muni);
    setFieldValue("Cel", resSol[0].Cel);
    setFieldValue("E_Sexo", resSol[0].E_Sexo);
    setFieldValue(
      "FechaNac",
      formatearFechaNacimiento(resSol[0].fechanacimiento)
    );
    setFieldValue(
      "FechaNace",
      formatearFechaNacimiento(resSol[0].fechanacimiento)
    );
  };
  const setearCombosGrados = () => {
    setCombosGrados({
      ...combosGrados,
      idGrado: datosInscripcion.Grado,
      idCarrera: datosInscripcion.Carrera,
      idSede: datosInscripcion.Sede,
      idPlan: datosInscripcion.Plan,
    });
  };

  const getFotoN = async (id) => {
    setFieldValue("FotoN", "")
    const resSol = await fetchApi({
      url: url + "/inscripciones/subirfoto",
      headers: headers,
      content: {
        "IdSolicitud": id
      },
    });
    resSol.msg.Mensaje && setFieldValue("FotoN", resSol.msg.Mensaje)

  }
  useEffect(() => {
    //si callFromReporte ? jalar la data y asignarsela a solicitudselecionada : nada

    datosGridSeleccionado(
      callFromReporte ? solicitudSeleccionada.id : solicitudSeleccionada.Id
    );
    obtenerCombos();
    setearCombosGrados();
    obtenerNombreDelPlan(solicitudSeleccionada?.IdPlan);
    getDataEncargado(
      callFromReporte ? solicitudSeleccionada.id : solicitudSeleccionada.Id
    );
    getFotoN(solicitudSeleccionada.Id)
    setCarnetId({
      Id: callFromReporte ? solicitudSeleccionada.id : solicitudSeleccionada.Id,
      Carnet: solicitudSeleccionada.Carnet,
    });
  }, [callFromReporte ? solicitudSeleccionada?.id : solicitudSeleccionada?.Id]);

  const obtenerNombreDelPlan = (idDelPlan) => {
    let nombre = todosPlanes.filter((plan) => plan.IdPlan === idDelPlan);
    setNombrePlan(nombre[0]?.NombrePlan);
    return nombre[0]?.NombrePlan;
  };

  const sendData = (errors) => {

    if (isValid) {

      setFieldValue("IdGrado", idsCombos.IdGrado);
      setFieldValue("IdSede", idsCombos.IdSede);
      setFieldValue("IdPlan", idsCombos.IdPlan);
      setFieldValue("IdCarrera", idsCombos.IdCarrera);
      //values.Carreraventana =
      enviarFotoActualizacion(values, carnetId.Id)
      handleSubmit(
        values,
        setFieldValue,
        false, //era true
        carnetId.Id,
        carnetId.Carnet,
        true
      );
      // cambiar el objeto de planesVentana para que se lea actualizado en el caso de no cambiarlo:

      // fin de tal funcion
      closeAdmisionEdicion();
    }
  };

  const datosGridSeleccionado = (idSeleccionado) => {
    if (idSeleccionado !== undefined) {
      let solicitud = datosSolicitud.filter(
        (dato) => dato.Id === idSeleccionado
      );
      solicitud = solicitud[0];
      setGridSeleccionado({
        ...gridSeleccionado,
        Carrera: solicitud.Carrera,
        Grado: solicitud.Grado,
        Sede: solicitud.Sede,
        Plan: obtenerNombreDelPlan(solicitud.IdPlan)
      });

      sendPlanes(gridSeleccionado)
    }
  };

  useEffect(() => {
    sendPlanes(gridSeleccionado)
  }, [gridSeleccionado])


  

  const handleLocal = (e, setFieldValue, Idsede, opcion) => {
    // Sedes: llena planes y reset carreras y grados
    switch (opcion) {
      case 1:
        handlePlanes(e.target.value, setFieldValue);
        handleCarreras("", setFieldValue, e.target.value);
        handleGrados("", setFieldValue, e.target.value);
        break;
      case 2:
        handleCarreras(e.target.value, setFieldValue, Idsede);
        handleGrados("", setFieldValue, Idsede);
        break;
      case 3:
        handleGrados(e.target.value, setFieldValue, Idsede);
        break;
      case 4:
        handleCuotas(e.target.value, setFieldValue, Idsede);
        break;
      default:
        break;
    }
    obtenerDatosInscripcion(
      [e.target.name][0], //nombre del campo
      e.target.options[e.target.selectedIndex].text, //texto del campo
      e.target.value, //value del campo
      2
    );
    /*  
      setIdsCombos({
        ...idsCombos,
        [e.target.name]: e.target.value,
      });
      */
  };

  const handleNacBlur = async(values) => {
    console.log(values)
    // fechaRef.current.focus() 
    const resFnace = await fetchApi({
      method: "GET",
      url: props.url + "/inscripciones/validafechanace",
      headers: props.headers,
      content: {
          FNacimiento: fechaSinGuiones(values.FechaNac), //año mes dia sin diagonales
          IdGrado: values.IdGrado,
          Nombres: values.Nombres,
          Apellidos: values.Apellidos,
          Email: values.Email,
          IdEmp: props.IdEmp
      },
   });

   if(resFnace.msg[0].estado === 0){ // si tiene error, lanza el mensaje
    setModal({
        ok:false,
        msg: `${resFnace.msg[0].mensaje} según ${resFnace.msg[0].AcuerdoMinisterial}`,
        show:true,
    })
    setDataGridFecha(resFnace.msg)
    return false
  }else{
    return true
  }
   
   

   // al mostrar el error, devolver el foco al input de la fecha para que no salga del bucle
  }

  useEffect(() => {
  function handlePress(event) {
    if (document.activeElement.type === "number") {
        if (!`${event.target.value}${event.key}`.match(/^[0-9]*[^\W]/)) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    }

    if (document.activeElement.type === "text") {
      if (!`${event.target.value}${event.key}`.match(/^[A-Z|ÁÉÍÓÚ|a-z|áéíóú|\s]*$/)) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }
  }
  window.addEventListener("keypress", handlePress);
  return () => {    
      window.removeEventListener("keypress", handlePress);
  }

  }, [])

  return (
    <>
      <div className=" lg:w-[85%] sm:w-[100%] h-[80%] relative  bg-secundarioMira">
        <div className="grid grid-cols-1 sm:px-0 sm:py-0 sm:gap-0 sm:grid-cols-1 lg:grid-cols-6 grid-rows-8   lg:px-4 lg:py-4 lg:gap-2">
          { }
          { }
          <div className="row-span-3 ">

            <div className="row-span-full col-start-4 shadow-xl mb-2">
              <PreviewImage
                file={values.FotoN}
                className="h-[7.3rem] w-full object-contain rounded-t-lg"
              />
              <div className="w-full bg-azulBrillanteMira rounded-b-lg py-2 px-3">
                <input
                  ref={fileRef}
                  type="file"
                  hidden
                  onChange={async (e) => {
                    const base64String = await convertBlobToBase64(
                      e.target.files[0]
                    );
                    setFieldValue("FotoN", base64String);
                  }}
                />
                <button
                  className="w-full text-white text-sm font-semibold hover:underline"
                  type="button"
                  onClick={() => {
                    fileRef.current.click();
                  }}
                >
                  Agregar Fotografía
                </button>
                {errors?.FotoN && (
                  <div className="ml-4 text-sm font-medium text-secundario">
                    {errors?.FotoN}
                  </div>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 bg-primarioMira col-span-2 px-4 py-4 rounded-xl">
              <div
                className="col-span-full row-span-1 bg-white">
              </div>
              <h2 className="col-span-full text-sm   text-white">Solicitud</h2>
              <h2 className="grid text-sm text-secundario">
                {solicitudSeleccionada?.Id}
              </h2>
              <h2 className="col-span-full text-sm text-white mt-4">
                Aspirante{" "}
              </h2>
              <h2 className="flex justify-between text-sm text-secundario ">
                {" " +
                  solicitudSeleccionada?.Nombres +
                  " " +
                  solicitudSeleccionada?.Apellidos}
              </h2>
              <h2 className="col-span-full text-sm text-white mt-4">Campus </h2>
              <h2 className="flex text-sm text-secundario ">
                {gridSeleccionado.Sede}
              </h2>

              <h2 className="col-span-full text-sm text-white mt-4">Plan</h2>
              <h2 className="grid text-sm text-secundario ">{nombrePlan}</h2>

              <h2 className="col-span-full text-sm text-white mt-4">
                Nivel académico
              </h2>
              <h2 className="grid text-sm text-secundario ">
                {gridSeleccionado.Carrera}
              </h2>

              <h2 className="col-span-full text-sm text-white mt-4">
                Grado a inscribir
              </h2>
              <h2 className="grid text-sm text-secundario">
                {gridSeleccionado.Grado}
              </h2>
            </div>
          </div>
          { }
          { }
          <div className="lg:grid lg:grid-cols-5 sm:grid-cols-1   bg-primarioMira  shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl lg:col-span-5 col-span-5 gap-4 px-4 py-4">
            <div className="col-span-5 text-white mb-2"><p>*Nota: la solicitud se guardará con sede , plan, nivel y grado seleccionados</p></div>
            <div className="col-span-1">
              <label
                lbl="Selecciona el plan de estudios"
                field="IdPlan"
                className="flex text-sm font-medium leading-7 text-white"
              >
                Campus
              </label>
              <Field
                onChange={(e) => handleLocal(e, setFieldValue, "", 1)}
                name="IdSede"
                as="select"
                className="mt-1 block  w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              >
                <option value="">---Selecciona campus---</option>
                {options?.sedes?.map((sede) => (
                  <option key={sede.IdSede} value={sede.IdSede}>
                    {sede.Sede}
                  </option>
                ))}
              </Field>
            </div>

            <div className="col-span-1">
              <label
                lbl="Selecciona el plan de estudios"
                field="IdPlan"
                className="flex text-sm font-medium leading-7 text-white"
              >
                Plan
              </label>
              <Field
                onChange={(e) =>
                  handleLocal(e, setFieldValue, values.IdSede, 2)
                }
                name="IdPlan"
                as="select"
                className="mt-1 block w-full   rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              >
                <option value="">---Selecciona plan---</option>
                {planes?.length > 0
                  ? planes?.map((plan) => (
                    <option key={plan.IdPlan} value={plan.IdPlan}>
                      {plan.NombrePlan}
                    </option>
                  ))
                  : null}
              </Field>
            </div>

            <div className="col-span-2">
              <label
                lbl="Selecciona la carrera a cursar"
                field="IdCarrera"
                className="flex text-sm font-medium leading-7 text-white"
              >
                Nivel académico
              </label>
              <Field
                onChange={(e) =>
                  handleLocal(e, setFieldValue, values.IdSede, 3)
                }
                name="IdCarrera"
                as="select"
                ref={carreraRef}
                className="mt-1 w-full inline rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              >
                <option value="">---Selecciona nivel académico---</option>
                {carreras?.length > 0
                  ? carreras?.map((carrera) => (
                    <option
                      key={carrera?.IdCarrera}
                      value={carrera?.IdCarrera}
                    >
                      {carrera?.Nombre}
                    </option>
                  ))
                  : null}
              </Field>
            </div>
            <div className="col-span-1">
              <label
                lbl="Selecciona el grado"
                field="IdGrado"
                className="flex  w-full text-sm font-medium leading-7 text-white"
              >
                Grado
              </label>
              <Field
                onChange={(e) =>
                  handleLocal(e, setFieldValue, values.IdSede, 4)
                }
                name="IdGrado"
                as="select"
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
              >
                <option value="">---Selecciona grado---</option>
                {grados?.length > 0
                  ? grados?.map((grado) => (
                    <option key={grado.IdGrado} value={grado.IdGrado}>
                      {grado.Nombre}
                    </option>
                  ))
                  : null}
              </Field>
            </div>
          </div>
          { }
          <div className="  bg-primarioMira text-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl lg:col-span-5">
            <h2 className="text-sm font-medium leading-7 text-white px-4">
              Datos del aspirante:
            </h2>
            <div className="px-4 py-6 sm:p-4 text-white">
              <div className="grid gap-3 grid-cols-1 sm:gap-3 lg:grid-cols-4  xl:grid-cols-5  lg:gap-x-6 lg:gap-y-8 ">
                <div className="sm:col-span-1 ring-gray-900/5 py-2 px-2 col-span-full  bg-secundarioMira rounded-lg border border-grisMira shadow-2xl">
                  <label
                    htmlFor="Genero"
                    field="Genero"
                    className="flex text-sm font-medium leading-7 text-white"
                  >
                    Género
                  </label>

                  <div>
                    <span className="text-sm  text-gray">
                      Masculino
                    </span>
                    <Field
                      type="radio"
                      className="ml-1 mr-2 text-salmon cursor-pointer "
                      value="M"
                      name="Genero"
                      checked={values?.Genero === "M"}
                    />
                    <span className="text-sm  text-grey">
                      Femenino
                    </span>
                    <Field
                      type="radio"
                      className="ml-1 text-salmon cursor-pointer"
                      value="F"
                      name="Genero"
                      checked={values?.Genero === "F"}
                    />
                  </div>
                </div>
                <div className="sm:col-span-1 ">
                  <label
                    htmlFor="FechaNac"
                    className="flex text-sm font-medium leading-7 text-white"
                  >
                    Fecha de Nacimiento
                  </label>
                  <div className="mt-2">
                    <div className="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md text-black">
                      <Field
                        type="date"
                        innerRef={fechaRef}
                        name="FechaNac" // on Blur validar
                        //onBlur={()=> handleNacBlur(values)}
                        //max="2020-01-01"
                        // onKeyUp={(e) => handleBlur(e, errors)}
                        className="block  w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:border-secundario sm:text-sm sm:leading-6"
                      />
                      {errors?.FechaNac && (
                        <div className="ml-4 text-sm font-medium text-secundario">
                          {errors?.FechaNac}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-span-2">
                  <label
                    htmlFor="ColAnterior"
                    className="flex text-sm font-medium leading-7 text-white"
                  >
                    Colegio anterior
                  </label>
                  <div className="mt-2">
                    <Field
                      id="ColAnterior"
                      name="ColAnterior"
                      type="text"
                      customOnChange={true}
                      placeholder="Colegio anterior"
                      className="mt-1 block w-full rounded-md border-gray-300  shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm text-black"
                    />
                    {errors?.ColAnterior && (
                      <div className="ml-4 text-sm font-medium text-secundario">
                        {errors?.ColAnterior}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-span-1">


                </div>
              </div>
            </div>
          </div>
          { }
          <div className="col-span-5  row-span-2">
            <div className="bg-primarioMira shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl lg:col-span-5">
              <h2 className="text-sm font-medium leading-7 text-white px-4">
                Datos del encargado del aspirante:{" "}
              </h2>
              <div className="lg:grid  grid-cols-5  px-4 gap-4">
                <div className="col-span-3">
                  <label
                    htmlFor="E_Nombres"
                    className="flex text-sm font-medium leading-7 text-white"
                  >
                    Nombres
                  </label>

                  <Field
                    id="E_Nombres"
                    name="E_Nombres"
                    type="text"
                    placeholder="Nombres"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                  />
                  {errors?.engardado && (
                    <div className="ml-4 text-sm font-medium text-secundario">
                      {errors?.encardado}
                    </div>
                  )}
                </div>

                <div className="col-span-2">
                  <label
                    htmlFor="E_Apellidos"
                    className="flex text-sm font-medium leading-7 text-white"
                  >
                    Apellidos
                  </label>

                  <Field
                    id="E_Apellidos"
                    name="E_Apellidos"
                    type="text"
                    placeholder="Apellidos"
                    className=" mt-1 block w-full rounded-md border-gray-300  shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                  />
                  {errors?.E_Apellidos && (
                    <div className="ml-4 text-sm font-medium text-secundario">
                      {errors?.E_Apellidos}
                    </div>
                  )}
                </div>
              </div>
              <CompletarDatosCampos
                setFieldValue={setFieldValue}
                values={values}
                url={url} //editado
                headers={headers}
                solicitudSeleccionada={solicitudSeleccionada}
                errors={errors}
              />
            </div>
          </div>
          { }
        </div>
        <div className="flex items-center justify-center lg:justify-end gap-x-6 border-t border-gray-900/10 px-4 py-2 sm:px-4 ">
          <button
            onClick={closeAdmisionEdicion}
            type="button"
            className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
          >
            Cancelar
          </button>
          <button
            type="submit"
            onClick={() => handleNacBlur(values) ? 
                (Object.entries(errors).length === 0 && sendData(errors)) && setBotonProveniente("ACTUALIZAR")
              : null}
            className="relative inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulLogos hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
          >
            Guardar
          </button>
        </div>

        {/*)*/}
      </div>
    </>
  );
}
